// extracted by mini-css-extract-plugin
export default {"btn":"BackBtn_btn__W1jMT","backbtnslider":"BackBtn_backbtnslider__cw3N7","previewbtn":"BackBtn_previewbtn__GWcbL"};